// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div[id='@bluedolphin/auth-mf'] {
    box-sizing: border-box;
    font-family: 'Robot Light', sans-serif;
    font-weight: 400;
}

.layout__wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    min-height: 100vh;
     
    background: url('https://bdcdnstorageprd.blob.core.windows.net/images/BlueDolphin_Screen_Visual_4.jpg');

    background-repeat: no-repeat;
    background-size: cover;
}

.backdrop-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: auto;
    min-height: 100vh;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5px);
}

.layout__children {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.layout__footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 56px;
    padding: 16px;
    background-color: #ffffff;
    margin-top: 40px;
}

.layout__footer__left > a {
    margin-left: 20px;
}

.layout__footer__left > a:first-child {
    margin-left: 0px;
}

.layout__footer__right > a {
    margin-right: 20px;
}

.layout__footer__right > a:last-child {
    margin-right: 0px;
}

.loader {
    margin-top: 30px;
}

.idp__list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.idp__list__links {
    width: 448px;
    display: flex;
    justify-content: center;
    gap: 16px;
    align-self: stretch;
    align-items: center;
    padding: 8px 0px;
}

.idp__list__wrapper {
    display: flex;
    width: 240px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px 0px;
}

.signup__wrapper {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.network-snackbar--navbar .notistack-SnackbarContainer {
    top: 76px !important;
}

div[id='@bluedolphin/auth-mf'] .MuiPaper-root.MuiAlert-root {
    width: fit-content !important;
}

div[id='@bluedolphin/auth-mf'] .notistack-SnackbarContainer {
    top: 62px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;;IAEjB,uGAAuG;;IAEvG,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,SAAS;AACb","sourcesContent":["div[id='@bluedolphin/auth-mf'] {\n    box-sizing: border-box;\n    font-family: 'Robot Light', sans-serif;\n    font-weight: 400;\n}\n\n.layout__wrapper {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    height: auto;\n    min-height: 100vh;\n     \n    background: url('https://bdcdnstorageprd.blob.core.windows.net/images/BlueDolphin_Screen_Visual_4.jpg');\n\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.backdrop-container {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    height: auto;\n    min-height: 100vh;\n    background-color: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(5px);\n}\n\n.layout__children {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.layout__footer {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 56px;\n    padding: 16px;\n    background-color: #ffffff;\n    margin-top: 40px;\n}\n\n.layout__footer__left > a {\n    margin-left: 20px;\n}\n\n.layout__footer__left > a:first-child {\n    margin-left: 0px;\n}\n\n.layout__footer__right > a {\n    margin-right: 20px;\n}\n\n.layout__footer__right > a:last-child {\n    margin-right: 0px;\n}\n\n.loader {\n    margin-top: 30px;\n}\n\n.idp__list {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n}\n\n.idp__list__links {\n    width: 448px;\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    align-self: stretch;\n    align-items: center;\n    padding: 8px 0px;\n}\n\n.idp__list__wrapper {\n    display: flex;\n    width: 240px;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 16px 0px;\n}\n\n.signup__wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n.network-snackbar--navbar .notistack-SnackbarContainer {\n    top: 76px !important;\n}\n\ndiv[id='@bluedolphin/auth-mf'] .MuiPaper-root.MuiAlert-root {\n    width: fit-content !important;\n}\n\ndiv[id='@bluedolphin/auth-mf'] .notistack-SnackbarContainer {\n    top: 62px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
